<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.852"
      height="14.852"
      viewBox="0 0 14.852 14.852"
      class="scaling-svg"
    >
      <g id="print" transform="translate(0.25 0.25)">
        <path
          d="M13.23,4.485h-.9V2.242a.449.449,0,0,0-.448-.448h-.9V.673A.674.674,0,0,0,10.315,0H4.036a.674.674,0,0,0-.673.673V1.794h-.9a.449.449,0,0,0-.448.448V4.485h-.9A1.122,1.122,0,0,0,0,5.606v4.933a1.122,1.122,0,0,0,1.121,1.121H3.364v2.018a.674.674,0,0,0,.673.673h6.279a.674.674,0,0,0,.673-.673V11.661H13.23a1.122,1.122,0,0,0,1.121-1.121V5.606A1.122,1.122,0,0,0,13.23,4.485ZM11.885,2.242V4.485h-.9V2.242ZM3.812.673A.225.225,0,0,1,4.036.448h6.279a.225.225,0,0,1,.224.224V4.485H3.812ZM2.467,2.242h.9V4.485h-.9Zm8.073,11.436a.225.225,0,0,1-.224.224H4.036a.225.225,0,0,1-.224-.224V9.867h6.727ZM13.9,10.539a.674.674,0,0,1-.673.673H10.988V9.867h.448a.224.224,0,0,0,0-.448H2.915a.224.224,0,0,0,0,.448h.448v1.345H1.121a.674.674,0,0,1-.673-.673V5.606a.674.674,0,0,1,.673-.673H13.23a.674.674,0,0,1,.673.673Z"
          stroke="currentColor"
          stroke-width="0.5"
        />
        <path
          d="M432.673,192a.673.673,0,1,0,.673.673A.674.674,0,0,0,432.673,192Zm0,.9a.224.224,0,1,1,.224-.224A.225.225,0,0,1,432.673,192.9Z"
          transform="translate(-419.891 -186.618)"
        />
        <path
          d="M368.673,192a.673.673,0,1,0,.673.673A.674.674,0,0,0,368.673,192Zm0,.9a.224.224,0,1,1,.224-.224A.225.225,0,0,1,368.673,192.9Z"
          transform="translate(-357.685 -186.618)"
        />
        <path
          d="M172.933,376h-4.709a.224.224,0,0,0,0,.448h4.709a.224.224,0,0,0,0-.448Z"
          transform="translate(-163.291 -365.461)"
          stroke="currentColor"
          stroke-width="0.5"
        />
        <path
          d="M172.933,416h-4.709a.224.224,0,0,0,0,.448h4.709a.224.224,0,0,0,0-.448Z"
          transform="translate(-163.291 -404.339)"
          stroke="currentColor"
          stroke-width="0.5"
        />
        <path
          d="M172.933,456h-4.709a.224.224,0,0,0,0,.448h4.709a.224.224,0,0,0,0-.448Z"
          transform="translate(-163.291 -443.218)"
          stroke="currentColor"
          stroke-width="0.5"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class PrinterIcon extends Vue {}
</script>

<style></style>
